var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.options!== null && _vm.options.attrs!==null)?_c('el-button',{attrs:{"type":_vm.options.attrs.type,"round":_vm.options.attrs.round}},[_vm._v("\n  "+_vm._s(_vm.options.value)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }